import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { DOCKET_PATH } from './lib/complaints'
import { ADMIN_PATH } from './lib/admin'
import { AdminPage } from './pages/AdminPage'
import { DocketPage } from './pages/DocketPage'
import { FilePage } from './pages/FilePage'
import { ReceiptPage } from './pages/ReceiptPage'

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={FilePage} />
        <Route exact path="/complaint/:caseNumber" component={ReceiptPage} />
        {/* Unlisted. Nothing links here; the path is the only thing keeping it private. */}
        <Route exact path={DOCKET_PATH} component={DocketPage} />
        {/* Also unlisted, and on the same terms. */}
        <Route exact path={ADMIN_PATH} component={AdminPage} />
        <Route component={FilePage} />
      </Switch>
    </BrowserRouter>
  )
}
